import { Chip } from '@mui/material';
import route from '../../Router';
import { AddressMap } from '../../components/address/AddressMap';
import { AnalyticFilterFuncs } from '../../components/data/AnalyticFilter';
import DataTable, { ColumnData } from '../../components/data/DataTable';
import DataView from '../../components/data/DataView';
import { useIsSystemTenant } from '../../models/Hooks';
import { hasKey } from '../../models/Identity';
import { House } from '../../models/Types';
import { isMobile } from '../../utils';
import InhabitantCombo, { inhabitantStore } from '../inhabitants/InhabitantCombo';
import { HouseDto, HouseForm } from './HouseForm';
import HouseList from './HouseList';

const columns: ColumnData<HouseDto>[] = [{
    label: 'Улица',
    name: 'Street',
    filter: true,
    routerLink: true
}, {
    label: '№ дома',
    name: 'Number',
    filter: true
}, {
    label: 'Адрес',
    name: 'Address',
    filter: true
}, {
    label: 'Владелец',
    name: 'OwnerId',
    store: inhabitantStore,
    filter: (onChange) => <InhabitantCombo onChange={e => onChange(e.target.value)} />,
    renderer: (val, obj) => inhabitantStore.data?.find(x => x.Id == val)?.Value
}, {
    label: 'Площадь участка',
    name: 'LandArea',
    type: 'numeric',
    filter: true
}, {
    label: 'Площадь домовладения',
    name: 'Area',
    type: 'numeric',
    filter: true
}, {
    label: 'Жильцов',
    name: 'Residents',
    type: 'numeric',
    filter: true
}, {
    label: 'Задолжность',
    name: 'Duty',
    type: 'money',
    filter: true,
    renderer: (v, o, th, ta, renderer) => v ? <Chip size="small" color="warning" label={renderer(v, o, th, ta, renderer)} /> : null
}, {
    label: 'Баланс',
    name: 'Balance',
    type: 'money',
    filter: true
}];

const systemColumns = columns.filter(x => x.name !== 'Residents' && x.name !== 'Area' && x.name !== 'LandArea');

const analyticFilters: { [key: string]: AnalyticFilterFuncs } = {
    Всего: {
        percent: (d, i, a) => 1
    },
    Домов: {
        percent: (d, i, a) => d?.value ? (d?.sub || 0) / d?.value : 0
    }
};

export function HouseTitle() {
    const iss = useIsSystemTenant();
    return iss ? 'Адреса' : 'Домовладения';
}

export default function HouseView() {
    const iss = useIsSystemTenant();

    return <DataView<House>
        title="Домовладение"
        titleMultiple="Домовладения"
        newTitle="Новое домовладение"
        typeId="House"
        //guide="locationsGuide"
        /**
        analyticFilter={{
            url: "LocationAnalyticFilter",
            percent: (d, item, all) => analyticFilters[item.key]?.percent ? analyticFilters[item.key].percent!(d, item, all) : 0,
            sub: (x, item) => item.key === 'Домов' ? (x?.sub || 0) + ' домохозяйств' : null,
            value: x => x?.value,
            items: [{
                icon: <LocationOn fontSize="large" />,
                key: 'Всего'
            }, {
                color: "success",
                icon: <HolidayVillage fontSize="large" color="info" />,
                key: 'Домов'
            }]
        }}
        /**/
        modes={[{
            mode: 'list',
            text: <>Список</>,
            hideAddBtn: !hasKey('House')
        }, {
            mode: 'board',
            text: <>Карта</>,
            hideAddBtn: !hasKey('House'),
            view: () => <AddressMap<HouseDto> cmd="HouseList" />
        }]}
        form={(id, apiRef) => <HouseForm id={id} apiRef={apiRef} lat={route.get('lat')} lon={route.get('lon')} readOnly={!hasKey('House')} />}
        tableRenderer={p => isMobile() ? <HouseList {...p} /> : <DataTable<House> {...p} />}
        tableProps={{
            columns: iss ? systemColumns : columns
        }} />;
}